module.exports = __webpack_public_path__ + "static/media/1.4.9f118d73.png";